module.exports = __webpack_public_path__ + "static/media/MahindravideoWeb.11427a0f.mp4";